<script setup lang="ts">
import { PopupType, usePopupNotifications } from "@/composables/popupNotifications";
import { whenRefAvailable } from "@/utilities/component";

const ItemCreated = useAsyncComponent(() => import("./ItemCreated.vue"));
const EmailNotVerified = useAsyncComponent(() => import("./EmailNotVerified.vue"));
const EmailVerificationResent = useAsyncComponent(() => import("./EmailVerificationResent.vue"));

const { toShowList, getPayload, markClosed } = usePopupNotifications();
watch(
  () => toShowList.value.size,
  () => toShowList.value.forEach((_, type) => openPopup(type))
);

type OpenablePopup = { open: () => unknown };

const ItemCreatedPopup = useTemplateRef<OpenablePopup | null>("itemCreatedPopup");
const EmailNotVerifiedPopup = useTemplateRef<OpenablePopup | null>("emailNotVerifiedPopup");
const EmailVerificationResentPopup = useTemplateRef<OpenablePopup | null>("emailVerificationResentPopup");

const openPopup = (type: PopupType): void => {
  const type2ComponentMap = {
    [PopupType.ItemCreated]: ItemCreatedPopup,
    [PopupType.EmailNotVerified]: EmailNotVerifiedPopup,
    [PopupType.EmailVerificationResent]: EmailVerificationResentPopup,
  };
  const component = type2ComponentMap[type];
  whenRefAvailable(component).then((d) => d.value.open());
};
</script>

<template>
  <ItemCreated v-if="toShowList.has(PopupType.ItemCreated)" ref="itemCreatedPopup" :item="getPayload(PopupType.ItemCreated)!" @close="markClosed(PopupType.ItemCreated)" />
  <EmailNotVerified v-if="toShowList.has(PopupType.EmailNotVerified)" ref="emailNotVerifiedPopup" @close="markClosed(PopupType.EmailNotVerified)" />
  <EmailVerificationResent v-if="toShowList.has(PopupType.EmailVerificationResent)" ref="emailVerificationResentPopup" @close="markClosed(PopupType.EmailVerificationResent)" />
</template>
